import { createQuestionValueMap, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultPolicyPurposeInformation: Map<string, ConfirmationData> = new Map([
    ["9ae03861-6748-4642-9dc6-4942a93a4c92", { fontWeight: "bold" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt1", { showBorder: false, type: "checkbox" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt2", { showBorder: false, type: "checkbox" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt3", { showBorder: false, type: "checkbox" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt4", { showBorder: false, type: "checkbox" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt5", { showBorder: false, type: "checkbox" }],
    ["9c35a59e-d7db-4222-982a-15f885d296b8-opt6", { showBorder: true, type: "checkbox" }],

    ["4f3c2646-7e78-4347-8eb0-0e9257270fd1", { fontWeight: "bold" }],
    ["c25850b2-4915-407a-8406-6023955d137c", { showBorder: false }],
    ["8bbf91bf-bca9-456f-9d6a-26850ce9d6c0", { type: "download", showBorder: true }],

    ["f06aebde-02db-43af-a687-474f29e9b2df", { fontWeight: "bold" }],
    ["f06aebde-02db-43af-a687-474f29e9b2df|7d73d0a4-5588-4199-aed5-cf1814a8c16a", { showBorder: true, type: "download" }],

    ["fb5f6faa-4103-490e-9841-3f4cbbd7e0a9", { fontWeight: "bold" }],
    ["fb5f6faa-4103-490e-9841-3f4cbbd7e0a9|7d73d0a4-5588-4199-aed5-cf1814a8c16a", { showBorder: true, type: "download" }],

    ["f4e5fdb4-09d5-47ce-8d35-a04c96068bfe", { fontWeight: "bold" }],
    ["0723c020-55d2-470d-8428-03c2f4f91dbf", { showBorder: true }],

    ["89baecb3-df3b-4420-aee3-f5f3f0702753", { fontWeight: "bold" }],
    ["de22c1a9-2745-4860-9909-f9430478c9e5", { showBorder: true }],
]);

export const updatePolicyPurposeInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    var answersMap = createQuestionValueMap(page);

    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}



